import React from 'react';
import 'fragments/announcements/announcements-list.scss';
import { Empty, Spin } from 'antd';
import dayjs from 'dayjs';
import { useTranslator } from 'tools/view-hooks/translator-hook';
import { useAnnouncementsTabController } from 'fragments/inbox/fragments/announcements-tab/announcements-tab.controller';
import { AnnouncementWithSite } from 'services/announcements/announcements.service';

const BODY_PREVIEW_LENGTH = 120;

export const AnnouncementsTabFragment: React.FC = () => {
    const { translate } = useTranslator();
    const { state, events } = useAnnouncementsTabController();

    const preview = (body: string) =>
        body.length > BODY_PREVIEW_LENGTH ? `${body.slice(0, BODY_PREVIEW_LENGTH)}…` : body;

    const renderCard = (item: AnnouncementWithSite) => (
        <button
            key={item.id}
            type={'button'}
            className={`announcements-card${item.read ? '' : ' announcements-card--unread'}`}
            onClick={() => events.onOpen(item)}
        >
            <span className={'announcements-card-meta'}>
                {!item.read && <span className={'announcements-card-dot'} aria-hidden />}
                {item.siteName} · {dayjs(item.publishedAt).format('DD/MM/YY HH:mm')}
            </span>
            <span className={'announcements-card-title'}>{item.title}</span>
            <span className={'announcements-card-preview'}>{preview(item.body)}</span>
        </button>
    );

    if (state.loading) {
        return <Spin className={'announcements-spin'} />;
    }

    if (state.announcements.length === 0) {
        return (
            <Empty
                className={'announcements-empty'}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                    <>
                        <p className={'announcements-empty-title'}>
                            {translate({ key: 'inbox.announcements-empty-title' })}
                        </p>
                        <p className={'announcements-empty-subtitle'}>
                            {translate({ key: 'inbox.announcements-empty-subtitle' })}
                        </p>
                    </>
                }
            />
        );
    }

    return <div className={'announcements-cards'}>{state.announcements.map(renderCard)}</div>;
};
